import React, { useEffect, useState } from 'react';
import NextPrevButtons from '../Shared/NextPrevButtons';
import { Button, Checkbox, makeStyles, TextField } from '@material-ui/core';
import { dataService } from '../../Services/data.service';
import { toast } from 'react-toastify';

export default function AddFormFreeClausesComponent(props) {
    const [clauses, setClauses] = useState([]);
    const [selectedClauses, setSelectedClauses] = useState([])
    const [remark, setRemark] = useState(props.addPage.remark.split("<br/>").join("\n"))

    const classes = useStyles();
    var placeholder = document.createElement("li");
    placeholder.className = "placeholder";

    useEffect(() => {      

        dataService.getFreeClauses().then(data => {

            let freeClauses = [...data.Results]
            let freeClausesNotSelected = []
            let selectedFreeClauses = []
            let allClauses = []
            var i;

            for (i = 0; i < freeClauses.length; i++) {

                if (props.addPage.selectedFreeClauses.some(x => x.ID === freeClauses[i].ID)) {
                    selectedFreeClauses.push({ ID: freeClauses[i].ID, Name: freeClauses[i].Name, Index: props.addPage.selectedFreeClauses.find(x => x.ID === freeClauses[i].ID).Index ,InformationTranslationID:freeClauses[i].InformationTranslationID,Information:freeClauses[i].Information})

                }
                else {
                    freeClausesNotSelected.push({ ID: freeClauses[i].ID, Name: freeClauses[i].Name,InformationTranslationID:freeClauses[i].InformationTranslationID,Information:freeClauses[i].Information })
                }
            }

            selectedFreeClauses = selectedFreeClauses.sort((a, b) => a.Index - b.Index)

            var y;
            for (y = 0; y < freeClausesNotSelected.length; y++) {
                freeClausesNotSelected[y]["Index"] = y + selectedFreeClauses.length
            }

            allClauses = selectedFreeClauses.concat(freeClausesNotSelected)

            if (JSON.stringify(allClauses) !== JSON.stringify(clauses)) {
                setClauses(allClauses)
                setSelectedClauses(selectedFreeClauses)
            }

        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

    }, [props.addPage.selectedFreeClauses]);

    const selectClause = (clauseID) => {
        let tempSelectedClauses = selectedClauses.slice()

        if (tempSelectedClauses.some(x => x.ID === clauseID)) {
            let index = tempSelectedClauses.indexOf(tempSelectedClauses.find(x => x.ID === clauseID))
            tempSelectedClauses.splice(index, 1)
        }
        else {
            tempSelectedClauses.push(clauses.find(x => x.ID === clauseID))
        }
        setSelectedClauses(tempSelectedClauses)
    }

    let goNext = () => {
        let sortedFreeClauses = [...clauses]
        let selectedSortedFreeClauses = []
        var i;

        for (i = 0; i < sortedFreeClauses.length; i++) {
            sortedFreeClauses[i].Index = i
            if (selectedClauses.some(x => x.ID === sortedFreeClauses[i].ID)) {
                selectedSortedFreeClauses.push({ ID: sortedFreeClauses[i].ID, Name: sortedFreeClauses[i].Name, Index: i,InformationTranslationID:sortedFreeClauses[i].InformationTranslationID,Information:sortedFreeClauses[i].Information })
            }
        }
 console.log(selectedSortedFreeClauses)
        props.actions.setSelectedFreeClauses(selectedSortedFreeClauses)
        props.actions.setRemark(remark)
        props.SetNext();
    };

    const onChangeText = (value) => {
        setRemark(value.target.value)
    }

    const initialDnDState = {
        draggedFrom: null,
        draggedTo: null,
        isDragging: false,
        originalOrder: [],
        updatedOrder: []
    }

    const DragToReorderList = () => {

        const [dragAndDrop, setDragAndDrop] = useState(initialDnDState);

        const dragStart = (event) => {
            const initialPosition = Number(event.currentTarget.dataset.position);

            setDragAndDrop({
                ...dragAndDrop,

                draggedFrom: initialPosition,
                isDragging: true,
                originalOrder: clauses
            });

            event.dataTransfer.setData("text/html", '');
        }

        const dragOver = (event) => {
            event.preventDefault();
            let newList = dragAndDrop.originalOrder;
            const draggedFrom = dragAndDrop.draggedFrom;
            const draggedTo = Number(event.currentTarget.dataset.position);
            const itemDragged = newList[draggedFrom];
            const remainingItems = newList.filter((item, index) => index !== draggedFrom);
            newList = [
                ...remainingItems.slice(0, draggedTo),
                itemDragged,
                ...remainingItems.slice(draggedTo)
            ];

            if (draggedTo !== dragAndDrop.draggedTo) {
                setDragAndDrop({
                    ...dragAndDrop,
                    updatedOrder: newList,
                    draggedTo: draggedTo
                })
            }
        }

        const onDrop = () => {
            setClauses(dragAndDrop.updatedOrder);
            setDragAndDrop({
                ...dragAndDrop,
                draggedFrom: null,
                draggedTo: null,
                isDragging: false
            });
        }

        return (
            <div>{
                clauses.map((item, i) => {
                    return (
                        <div
                            data-id={i}
                            data-position={i}
                            key={i}
                            draggable='true'
                            onClick = {() => selectClause(item.ID)}
                            onDrop={onDrop}
                            onDragOver={dragOver}
                            onDragStart={dragStart}
                            className={classes.item}>
                            <Checkbox
                                checked={selectedClauses.some(x => x.ID === item.ID)}
                                color="primary"
                                style={{marginBottom:"3px"}}
                                onChange={() => selectClause(item.ID)}
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                            />

                            {item.Name}</div>
                    )
                })

            }</div>)
    }

    return (
        <div className={classes.formContainer}>
            <div key="general">
                <div className={classes.title}>Select the clauses needed on the contract.</div>
                <div className={classes.subTitle}>Press and hold to change the order of the clauses.</div>

            </div>
            <div style={{ flex: 1, marginTop: 30, marginBottom: 20 }}>
                {/* <DraggableFlatList
                    data={clauses}
                    renderItem={renderItem}
                    keyExtractor={(item, index) => `draggable-item-${item.key}`}
                    onDragEnd={({ data }) => setClauses(data)}
                /> */}

                <DragToReorderList />
            </div>
            <div key="remarks">
                <div className={classes.remarks}>Add extra remarks here:</div>
            </div>
            <div style={{marginBottom:"20px"}}>
                <TextField id="outlined-search" placeholder={"Enter remarks"} type="search" defaultValue={props.addPage.remark.split("<br/>").join("\n")} variant="outlined" multiline={true} className={classes.uiTextField} size="small" onChange={(value) => { onChangeText(value) }} />
            </div>
            <NextPrevButtons
                hasPrevious={props.hasPrevious}
                hasNext={props.hasNext}
                SetPrevious={props.SetPrevious}
                SetNext={goNext}>
            </NextPrevButtons>
        </div>
    );
}

const useStyles = makeStyles({
    formContainer: {
        width: "1000px",
        marginLeft: "auto",
        marginRight: "auto",
        boxSizing: "border-box",
        paddingTop:"30px"
    },
    title: {
        fontSize: 22,
        fontFamily:"Roboto"
    },
    subTitle: {
        fontSize: 14,
        fontFamily:"Roboto"
    },
    remarks: {
        fontSize: 22,
        fontFamily:"Roboto",
        marginBottom:"10px"
    },
    uiTextField: {
        width: "100%",
        backgroundColor: "white"
    },
    item:{
        fontFamily:"Roboto",
        cursor:"pointer",
        '&:hover': {
            backgroundColor: 'rgb(25, 118, 210,0.1)',
       },  

    }
});